import React from 'react';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { adminColors } from '../../../../styles/adminDesignTokens';
import {
  adminButtonSx,
  adminButtonToneSx,
  adminCombineSx,
  adminDialogActionsSx,
  adminDialogContentSx,
  adminDialogSx,
  adminDialogTitleSx,
  adminFileInputOverlaySx,
  adminIconActionButtonSx,
  adminUploadDropzoneContentSx,
  adminUploadDropzoneSx,
} from '../../../../styles/adminComponentStyles';

interface DashboardGamesUploadDialogProps {
  open: boolean;
  selectedCsvFile: File | null;
  onClose: () => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
  onUpload: () => void;
}

const DashboardGamesUploadDialog: React.FC<DashboardGamesUploadDialogProps> = ({
  open,
  selectedCsvFile,
  onClose,
  onFileChange,
  onRemoveFile,
  onUpload,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ sx: adminDialogSx }}>
    <DialogTitle sx={adminDialogTitleSx}>Upload Games</DialogTitle>
    <DialogContent sx={adminDialogContentSx}>
      <Box sx={adminCombineSx(adminUploadDropzoneSx, { minHeight: 112 })}>
        <Box sx={adminCombineSx(adminUploadDropzoneContentSx, { minHeight: 112 })} width="100%">
          {selectedCsvFile ? (
            <>
              <InsertDriveFileRoundedIcon sx={{ color: adminColors.primary, fontSize: 32 }} />
              <Typography className="AdminUploadDropzone-label">
                {selectedCsvFile.name}
              </Typography>
              <IconButton
                aria-label="Remove selected CSV"
                size="small"
                onClick={onRemoveFile}
                sx={adminCombineSx(adminIconActionButtonSx, {
                  color: adminColors.danger,
                  position: 'absolute',
                  right: 4,
                  top: 4,
                })}
              >
                <DeleteOutlineRoundedIcon fontSize="inherit" />
              </IconButton>
            </>
          ) : (
            <>
              <UploadFileRoundedIcon fontSize="small" />
              <Typography className="AdminUploadDropzone-label">
                Upload CSV File
              </Typography>
              <Box
                component="input"
                type="file"
                accept=".csv"
                onChange={onFileChange}
                aria-label="Upload CSV file"
                sx={adminFileInputOverlaySx}
              />
            </>
          )}
        </Box>
      </Box>
    </DialogContent>
    <DialogActions sx={adminDialogActionsSx}>
      <Button onClick={onClose} variant="outlined" size="small" sx={adminCombineSx(adminButtonSx, adminButtonToneSx.secondary)}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onUpload}
        disabled={!selectedCsvFile}
        size="small"
        sx={adminCombineSx(adminButtonSx, adminButtonToneSx.primary)}
      >
        Upload
      </Button>
    </DialogActions>
  </Dialog>
);

export default React.memo(DashboardGamesUploadDialog);
